(function () {
  angular.module('binky.core.ui-event', ['binky.core.lodash']);
})();
